<template>
  <div class="personal-buy">
    <div v-for="item in packages" :key="item.id">
      <div
        :class="[
          'card',
          {
            active: item.id === picked?.id,
          },
        ]"
        @click.stop="handlePick(item)"
      >
        <div v-if="item.free_credit_coins > 0" class="coin-free">
          {{ $t('jia-song-itemfreecreditcoins-yan-bi', [item.free_credit_coins]) }}
        </div>
        <div class="price">
          <span class="price-prefix">
            {{ formatPrice(item.price).prefix }}
          </span>
          <span class="price-num">
            {{ formatPrice(item.price).value }}
          </span>
        </div>
        <div class="coin-count">
          <div class="coin-value">
            <Img :src="getFeUrl('/assets/credit.png')" class="coin-img" />
            {{
              $t('gong-itemtotalcreditcoins-yan-bi', [
                item.free_credit_coins
                  ? `${item.credit_coins}+${item.free_credit_coins}`
                  : item.credit_coins,
              ])
            }}
          </div>
          <div class="time-value">
            {{
              $t('yu-ji-sheng-chan-getavailabletimecountitemtotalcreditcoins-shi-pin', [
                getAvailableTimeCount(item.total_credit_coins),
              ])
            }}
            <Tooltip
              :content="
                $t(
                  'gen-ju-quan-ping-tai-yong-hu-ping-jun-xiao-hao-ji-suan-shi-ji-xiao-hao-yan-bi-shu-yi-ge-ren-zhi-zuo-xiao-hao-wei-zhun',
                )
              "
              placement="right"
            >
              <TipsIcon class="tip-icon" />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ICreditCoinsPackage } from '@rendora/common/entities/rights';
import { getI18nService } from '@rendora/common/services/i18n/index';
import { getGlobalConfig } from '@rendora/common/utils/config';
import { formatDuration, formatPrice } from '@rendora/common/utils/transform';
import { getFeUrl } from '@rendora/common/utils/url';
import TipsIcon from '@rendora/design/assets/tips.svg?component';
import { Img } from '@rendora/design/components/img/index';
import { Tooltip } from '@rendora/design/components/tooltip/index';

const i18nService = getI18nService();
const $t = i18nService.t;

const { isUS } = getGlobalConfig();

defineProps<{
  packages: ICreditCoinsPackage[];
  picked?: ICreditCoinsPackage;
}>();

const emits = defineEmits(['change']);

type DurationLike = { seconds: () => number; minutes: () => number; hours: () => number };

const getAvailableTimeCount = (totalCreditCoins: number) => {
  return formatDuration(totalCreditCoins * (isUS ? 0.3 : 0.2) * 1000, (d: DurationLike) => {
    const s = d.seconds();
    const m = d.minutes();
    const h = d.hours();
    let str = '';
    if (s > 0) {
      str = $t('dseconds-miao', [d.seconds()]);
    }
    if (m > 0 || h > 0) {
      str = `${m + h * 60}${$t('fen-zhong')}${str}`;
    }
    return str;
  });
};

const handlePick = (v: ICreditCoinsPackage) => emits('change', v);
</script>

<style scoped lang="scss">
.personal-buy {
  display: grid;
  --cols: v-bind('packages.length');
  grid-template-columns: repeat(min(3, var(--cols)), minmax(200px, 1fr));
  gap: 12px;
}
.card {
  position: relative;
  border: 1px solid var(--x-back-5);
  border-radius: var(--x-radius-medium);
  cursor: pointer;
  padding-top: 24px;
  padding-bottom: 24px;
  height: 140px;
  line-height: 1;
  .price {
    color: var(--x-text-1);
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
  }
  .coin-value {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--x-warning-10);
    font-weight: var(--x-weight-medium);
    font-size: 14px;
    margin: 12px 0;
  }
  .time-value {
    font-size: 12px;
    line-height: 1;
    color: var(--x-text-1-60);
    line-height: 1;
  }
}
.coin-count {
  text-align: center;
}
.price-prefix {
  font-size: 16px;
}
.price-num {
  font-size: 20px;
}
.active {
  &.active {
    border: 1px solid var(--x-purple-5);
    background-color: var(--x-purple-2);
  }
}
.coin-free {
  position: absolute;
  left: -1px;
  top: -1px;
  font-weight: var(--x-weight-medium);
  background-color: var(--x-error-6);
  border-radius: 4px 4px 4px 0px;
  color: #ffffff;
  font-size: 12px;
  padding: 2px 8px;
  line-height: 1;
}
.title {
  font-weight: var(--x-weight-medium);
  font-size: 14px;
}
.tip-icon {
  font-size: 12px;
  width: 12px;
  transform: translateY(5px);
  color: var(--x-text-1);
}
.coin-img {
  height: 20px;
  width: 20px;
}
</style>
